import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORGI_OAUTH_MIGRATION_CONFIG = createFcmDetails('corgi_oauth_migration_config', {
	owner: 'Site Platform',
	context: 'OAuth',
	description: `
		Configures OAuth migration.

		If enabled, corgi will replace uses of the old redis session with the OAuth provider and the new redis session

		Modes:
		- read-write: will write new OAuth sessions and load them (using legacy sessions as a fallback)
		- read: will write legacy sessions and read existing OAuth sessions (using legacy sessions as a fallback)
		- disabled: will write and read legacy sessions only

		If we enable the "read-write" mode and we find a bug, we can:
		1. switch to "read" so that we stop creating new OAuth sessions but we still can read them (=> not destroying active sessions)
		2. switch to "disabled" so that we stop reading OAuth sessions and we go back to the old behavior (=> this will "kick" users on OAuth session and they will have to log in again)

		Locale values are not supported.
	`,
	template: {
		enabled: true,
		mode: 'read-write',
	},
	import: false,
});
